__turbopack_context__.v({
  "itemsGroup": "ItemsGroup-module-scss-module__4RTG3q__itemsGroup",
});
